import * as React from 'react';
import { SearchLauncher } from '../components/SearchLauncher';

export function MapSearch({ floatPaddingLeft, floatPaddingRight }) {
  return (
    <SearchLauncher
      floating={true}
      floatPaddingLeft={floatPaddingLeft}
      floatPaddingRight={floatPaddingRight}
      hideSearchLocation={false}
      showQuickLinks={true}
    />
  );
};
